export default {
  label: {
    notClassifiedLabel: 'Not Classified',
    notClassifiedLabelPlural: 'Not Classified',
    notShowClassifiedLabel: 'Show Not Classified',
    showClassifiedLabel: 'Hide Not Classified',
  },
};
